/*
  NBV2 Platform Industries (sections/nbv2-platform-industries.liquid)

  Scroll-driven horizontal row, same idea as sections/nb-horizontal-scroll.liquid:
  on desktop the section is made tall enough to scroll the full row width, the
  row pins to the viewport, and vertical page scroll translates it sideways.

  The pinned mode only exists while this script adds the --pinned class, so
  on mobile (or with the script absent) the track stays the native
  scroll-snap scroller from assets/section-nbv2-platform-industries.css.
*/
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-nbv2-platform-industries]';
  var PINNED_CLASS = 'nbv2-platform-industries--pinned';
  var DESKTOP_QUERY = '(min-width: 990px)';

  function init(root) {
    if (root.nbv2PiInit === true) {
      return;
    }

    var sticky = root.querySelector('[data-nbv2-pi-sticky]');
    var track = root.querySelector('[data-nbv2-pi-track]');

    if (!sticky || !track) {
      return;
    }

    root.nbv2PiInit = true;

    var desktop = window.matchMedia(DESKTOP_QUERY);
    var scrollAmount = 0;
    var frame = null;

    function isPinned() {
      return root.classList.contains(PINNED_CLASS);
    }

    function render() {
      frame = null;
      if (!isPinned()) {
        return;
      }
      var progress = Math.max(0, Math.min(-root.getBoundingClientRect().top, scrollAmount));
      track.style.transform = 'translate3d(' + -progress + 'px, 0, 0)';
    }

    function requestRender() {
      if (frame === null) {
        frame = window.requestAnimationFrame(render);
      }
    }

    function layout() {
      if (!desktop.matches) {
        root.classList.remove(PINNED_CLASS);
        root.style.height = '';
        track.style.transform = '';
        return;
      }

      root.classList.add(PINNED_CLASS);
      scrollAmount = Math.max(0, track.scrollWidth - sticky.clientWidth);
      root.style.height = scrollAmount + sticky.offsetHeight + 'px';
      render();
    }

    var observer = null;
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(layout);
      observer.observe(track);
    }

    window.addEventListener('scroll', requestRender, { passive: true });
    window.addEventListener('resize', layout);
    desktop.addEventListener('change', layout);

    layout();

    root.nbv2PiDestroy = function () {
      window.removeEventListener('scroll', requestRender);
      window.removeEventListener('resize', layout);
      desktop.removeEventListener('change', layout);
      if (observer) {
        observer.disconnect();
      }
      if (frame !== null) {
        window.cancelAnimationFrame(frame);
      }
      root.nbv2PiInit = false;
      root.nbv2PiDestroy = null;
    };
  }

  function initAll(scope) {
    var container = scope || document;
    var roots = Array.prototype.slice.call(container.querySelectorAll(ROOT_SELECTOR));

    if (container.nodeType === 1 && container.matches && container.matches(ROOT_SELECTOR)) {
      roots.push(container);
    }

    roots.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var roots = Array.prototype.slice.call(event.target.querySelectorAll(ROOT_SELECTOR));
    roots.forEach(function (root) {
      if (typeof root.nbv2PiDestroy === 'function') {
        root.nbv2PiDestroy();
      }
    });
  });
})();
